import React from "react";
import { Box } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { Step3DeliveryConfig } from "pages/Alert/components/Step3DeliveryConfig";
import { AlertPreferencesBlockProps } from "../types";

/**
 * AlertPreferencesBlock - Block 2 content for Event preferences
 * Wraps the existing Step3DeliveryConfig component from Alert module
 *
 * FR-019: Reuse Step3DeliveryConfig completely
 * FR-020: Preserve all alert functionality
 */
export const AlertPreferencesBlock: React.FC<AlertPreferencesBlockProps> =
  observer(
    ({
      values,
      errors,
      touched,
      handleChange,
      setFieldValue,
      t,
      usersTableSelected,
      setUsersTableSelected,
      alertUsers,
    }) => {
      return (
        <Box>
          <Step3DeliveryConfig
            values={values}
            errors={errors}
            touched={touched}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            t={t}
            usersTableSelected={usersTableSelected}
            setUsersTableSelected={setUsersTableSelected}
            alertUsers={alertUsers}
          />
        </Box>
      );
    }
  );

AlertPreferencesBlock.displayName = "AlertPreferencesBlock";

export default AlertPreferencesBlock;
